export type KybDocType =
  | "certificate"
  | "articles"
  | "shareholders"
  | "address_proof"
  | "vat_certificate"
  | "business_license";

export type KybDoc = {
  id?: number | string;
  type: KybDocType;
  filename?: string | null;
  file_path?: string | null;
  status?: "approved" | "pending" | "rejected" | "missing";
  review_notes?: string | null;
  url?: string | null;
};

export const DOC_LABELS: Record<KybDocType, string> = {
  certificate: "Certificate of Incorporation",
  articles: "Articles of Association / Memorandum",
  shareholders: "Shareholder Register / Structure",
  address_proof: "Proof of Business Address",
  vat_certificate: "Tax/VAT Certificate",
  business_license: "Business License",
};
